<ng-container *ngIf="containsData; else noData">
	<mb-model-list
		[data]="data"
		[searchText]="searchText"
		[selectedFilters]="selectedFilters"
		[category]="category"
		[familyType]="familyType"
		[familyId]="familyId"
		[modelIdsList]="modelIdsList"
		[isAuthenticated]="isAuthenticated"
		[selectedFilters]="selectedFilters"
		[selectedModelsToCompare]="selectedModelsToCompare"
		[groupId]="groupId"
		[description]="description"
		(selectedModelsChanged)="selectedModels.emit($event)"
	></mb-model-list>
	<mb-inception-date class="dz-hidden dz-block-md" [familyId]="familyId" [groupId]="groupId"></mb-inception-date>
	<div *ngIf="showModelListPerformanceDisclosure" class="text-condensed-14 margin-top-20" dcrHTMLKey="MODEL_LIST_PERFORMANCE_DISCLOSURE"></div>
	<div *ngIf="showFamilyListHeaderDisclosure" class="dz-hidden dz-block-md" dcrHTMLKey="FAMILY_LIST_HEADER_DISCLOSURE"></div>
	<ac-disclosure class="dz-hidden dz-block-md" [isExpandable]="false" *ngIf="isAuthenticated && showModelListDisclosure">
		<section *ngIf="!(customAdvisoryFee$ | async)">
			<span dcrHTMLKey="NO_NET_PERF_DISCLOSURE">NO_NET_PERF_DISCLOSURE</span>
		</section>
		<span dcrHTMLKey="FAMILY_OVERVIEW_DISCLOSURE_PREFIX"> FAMILY_OVERVIEW_DISCLOSURE_PREFIX </span>
		<a
			target="_blank"
			[routerLink]="[appPaths.FUND_PERFORMANCE]"
			[queryParams]="{ familyId: familyId }"
			queryParamsHandling="merge"
			[attr.data-link-event]="'fund performance:' + familyType + ':' + category + ':' + familyId"
		>
			<span dcrHTMLKey="FAMILY_OVERVIEW_DISCLOSURE_LINK"> FAMILY_OVERVIEW_DISCLOSURE_LINK </span>
		</a>
		<span dcrHTMLKey="FAMILY_MODELS_PERFORMANCE_DISCLOSURE_PREFIX"> FAMILY_MODELS_PERFORMANCE_DISCLOSURE_PREFIX</span>
		<a
			target="_blank"
			[routerLink]="[appPaths.FAMILY + '/performance']"
			[queryParams]="{ familyId: familyId, groupId: this.groupId, subType: familyType }"
			queryParamsHandling="merge"
			[attr.data-link-event]="'model performance:' + familyType + ':' + category + ':' + familyId"
		>
			<span dcrHTMLKey="FAMILY_MODELS_PERFORMANCE_DISCLOSURE_LINK"> FAMILY_MODELS_PERFORMANCE_DISCLOSURE_LINK </span>
		</a>
	</ac-disclosure>
	<!-- expandable disclosure  -->
	<ac-disclosure class="dz-hidden dz-block-md" *ngIf="isAuthenticated && showModelListDisclosure">
		<span dcrHTMLKey="FAMILY_OVERVIEW_DISCLOSURE_SUFFIX_1">FAMILY_OVERVIEW_DISCLOSURE_SUFFIX_1 </span>
		<span *ngIf="groupId !== blkFamilyGroup || performanceBoxDisclosureEnabledBlkFamilies.includes(familyAladdinTicker$ | async)" dcrHTMLKey="FAMILY_OVERVIEW_DISCLOSURE_BOX">
			FAMILY_OVERVIEW_DISCLOSURE_BOX
		</span>
		<span dcrHTMLKey="FAMILY_OVERVIEW_DISCLOSURE_SUFFIX_2">FAMILY_OVERVIEW_DISCLOSURE_SUFFIX_2 </span>
	</ac-disclosure>
	<mb-family-footer *ngIf="showModelListDisclosure" class="dz-hidden dz-block-md" [familyId]="familyId" [showFundPerformanceLink]="false"></mb-family-footer>
</ng-container>
<ng-template #noData>
	<div class="row">
		<mb-model-list-empty-container></mb-model-list-empty-container>
	</div>
</ng-template>
